<div class="email-subscription" [class.email-subscription--success]="formState() === 'success'">
  @switch (formState()) {
    @case ('success') {
      <div class="email-subscription__result">
        <div class="email-subscription__icon email-subscription__icon--success">
          <img class="email-subscription__image" src="assets/v2/images/email-subscription.svg" alt="" />
          <span class="email-subscription__checkmark">
            <sd-icon [type]="iconTypes.SUCCESS"></sd-icon>
          </span>
        </div>
        <h3 class="email-subscription__title">Вы успешно подписались</h3>
      </div>
    }
    @default {
      <div class="email-subscription__icon">
        <img class="email-subscription__image" src="assets/v2/images/email-subscription.svg" alt="" />
      </div>

      <h3 class="email-subscription__title">статьи и всё о сервисах для строителей</h3>

      <form [formGroup]="form" class="email-subscription__form" (ngSubmit)="submit()">
        <sd-input class="email-subscription__input" label="e-mail" [error]="emailError">
          <input type="email" formControlName="email" autocomplete="email" sdAutofillUserData="email" />
        </sd-input>

        <button
          class="email-subscription__submit"
          sdButton
          theme="primary"
          size="l"
          type="submit"
          [loading]="isSubmitDisabled"
          [disabled]="isSubmitDisabled"
        >
          подписаться
        </button>

        <sd-checkbox formControlName="consent" class="email-subscription__checkbox">
          даю согласие на обработку
          <a routerLink="/personal_data" target="_blank">персональных данных</a>
        </sd-checkbox>
      </form>
    }
  }
</div>
